import React from 'react';
import './WhyTrustUs.css';

const WhyTrustUs = () => {
    const features = [
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                    <path d="M2 17l10 5 10-5"></path>
                    <path d="M2 12l10 5 10-5"></path>
                </svg>
            ),
            title: 'Smart Pricing Engine',
            description:
                'AI-powered MAP monitoring with instant violation detection and automated corrections',
            gradient: 'from-emerald-500 to-teal-500',
        },
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
            ),
            title: 'Brand Partnership Network',
            description:
                'Exclusive access to premium brand partnerships with verified authorization',
            gradient: 'from-blue-500 to-indigo-500',
        },
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M9 12l2 2 4-4"></path>
                    <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c1.5 0 2.91.37 4.15 1.02"></path>
                    <path d="M16 2l4 4-4 4"></path>
                </svg>
            ),
            title: 'Compliance Automation',
            description:
                'Zero-tolerance policy with automated enforcement across all marketplaces',
            gradient: 'from-purple-500 to-pink-500',
        },
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M3 3v18h18"></path>
                    <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
                </svg>
            ),
            title: 'Performance Analytics',
            description:
                'Real-time insights and performance tracking with detailed reporting',
            gradient: 'from-indigo-500 to-purple-500',
        },
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
                </svg>
            ),
            title: 'Lightning Fast Operations',
            description:
                'Same-day processing with premium fulfillment and instant updates',
            gradient: 'from-orange-500 to-red-500',
        },
        {
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                    <path d="M9 12l2 2 4-4"></path>
                </svg>
            ),
            title: 'Enterprise Security',
            description:
                'Bank-level security with complete data protection and privacy compliance',
            gradient: 'from-cyan-500 to-blue-500',
        },
    ];

    return (
        <section className="why-trust-us">
            <div className="why-trust-bg">
                <div className="bg-shape bg-shape-1"></div>
                <div className="bg-shape bg-shape-2"></div>
            </div>

            <div className="container">
                <div className="why-trust-header">
                    <div className="trust-badge">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                            <path d="M2 17l10 5 10-5"></path>
                            <path d="M2 12l10 5 10-5"></path>
                        </svg>
                        <span>AI-Powered MAP Protection</span>
                    </div>

                    <h2 className="why-trust-title">
                        <span className="trust-title-text">Why Brands </span>
                        <span className="trust-title-highlight">
                            Trust Avenis
                        </span>
                    </h2>

                    <p className="why-trust-description">
                        Our advanced AI-powered platform ensures 100% MAP
                        compliance while maximizing your authorized retail
                        performance. From automated pricing enforcement to
                        exclusive brand partnerships, we've revolutionized
                        smarter selling for premium brands.
                    </p>
                </div>

                <div className="features-grid">
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className="feature-card"
                            style={{ animationDelay: `${index * 100}ms` }}
                        >
                            <div className="feature-card-bg"></div>
                            <div
                                className={`feature-icon feature-icon-${
                                    index + 1
                                }`}
                            >
                                {feature.icon}
                            </div>
                            <h3 className="feature-title">{feature.title}</h3>
                            <p className="feature-description">
                                {feature.description}
                            </p>
                            <div
                                className={`feature-underline feature-underline-${
                                    index + 1
                                }`}
                            ></div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyTrustUs;
